module.exports = __webpack_public_path__ + "static/media/AliPayIcon.c857b905.svg";